import { wrapCreateBrowserRouterV6 as wrapCreateBrowserRouter } from '@sentry/react'
import { lazy } from 'react'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'

import System from 'system'

import Widget from './layout/Widget'

const InstitutionWidget = lazy(
  () => import(/* webpackChunkName: 'institutionwidget' */ '../pages/widgets/InstitutionWidget'),
)
const UserWidget = lazy(() => import(/* webpackChunkName: 'userwidget' */ '../pages/widgets/UserWidget'))

const Widget404 = lazy(() => import(/* webpackChunkName: 'widget404' */ '../pages/widgets/Widget404'))

let createRouter = createBrowserRouter

if (process.env.NODE_ENV === 'production' && System.sentry?.enabled) {
  createRouter = wrapCreateBrowserRouter(createBrowserRouter)
}

const router = createRouter(
  createRoutesFromElements(
    <Route element={<Widget />} path="/widgets">
      <Route element={<InstitutionWidget />} path="/widgets/institution/:id/soccer/:section?" />
      <Route element={<UserWidget />} path="/widgets/user/:id/soccer" />

      <Route element={<Widget404 />} path="*" />
    </Route>,
  ),
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
)

export default () => (
  <RouterProvider
    future={{
      v7_startTransition: true,
    }}
    router={router}
  />
)
